// Scheme Application

export const dealerRetailerInfo = 'dealer-retailer-panel/dealer-retailer-profile'
export const dealerRetailerInfoShow = dealerRetailerInfo + '/show'
export const dealerRetailerInfoStore = dealerRetailerInfo + '/store'
export const dealerRetailerInfoUpdate = dealerRetailerInfo + '/update'

// dealer retailer registration list
export const dealerRetailerRegistration = '/dealer-retailer-management/registration'
export const dealerRetailerRegList = dealerRetailerRegistration + '/list'

// dealer retailer security payment
export const securityPayment = '/dealer-retailer-management/security-payment'
export const checkPaymentEntry = securityPayment + '/check'
export const onlinePaymentEntry = securityPayment + '/online'
export const getSecurityMny = securityPayment + '/get-security-money'
export const secPaymentStatus = '/dealer-retailer-management/security-payment/'

export const committeDesigBase = 'configuration/add-class'
export const committeDesigListApi = committeDesigBase + '/list'
export const committeDesigStoreApi = committeDesigBase + '/store'
export const committeDesigShowApi = committeDesigBase + '/show'
export const committeDesigUpdateApi = committeDesigBase + '/update'
export const committeDesigStatusApi = committeDesigBase + '/toggle-status'
export const committeDesigDestroyApi = committeDesigBase + '/destroy'

//  promotion-entry
export const promotionEntryListApi = 'promotion-management/promotion-entry/list'
export const promotionEntryStoreApi = 'promotion-management/promotion-entry/store'
export const promotionEntryUpdateApi = 'promotion-management/promotion-entry/update'
export const promotionEntryToggleStatusApi = 'promotion-management/promotion-entry/toggle-status'
export const promotionEntryDestroyApi = 'promotion-management/promotion-entry/destroy'

// demand order entry
export const demandOrderEntryStoreApi = '/retailer-dealer-management/demand-order-entry/store'
export const demandOrderEntryListApi = '/retailer-dealer-management/demand-order-entry/external-list'

// quotation receive api
export const quotationListApi = 'dealer-retailer-panel/quotation-receive/list'
export const quotationReceiveStoreApi = 'dealer-retailer-panel/quotation-receive/store'
export const fiscalYearData = 'master-fiscal-year/show'

// delivery order receive api
export const deliveryReceiveApi = 'dealer-retailer-panel/delivery-order-receive/list'
export const deliveryReceivedListApi = 'dealer-retailer-panel/delivery-order-receive/received-list'
export const deliveryReceiveStoreApi = 'dealer-retailer-panel/delivery-order-receive/store'

// delivery order return apis
export const deliveryReturnStoreApi = 'dealer-retailer-panel/delivery-order-return/store'
export const returnProductListApi = 'dealer-retailer-panel/delivery-order-return/list'

// delivery order receive payment
export const deliveryRecPay = '/dealer-retailer-management/delivery-order-payment'
export const deliveryRecPayList = deliveryRecPay + '/get-order-list'
export const Paymentlist = deliveryRecPay + '/list'
export const PaymentShow = deliveryRecPay + '/show'
export const onlineOrderPaymentEntry = deliveryRecPay + '/online'
export const checkOrderPaymentEntry = deliveryRecPay + '/check'

// promotion dashboard
export const promotionDashboard = 'promotion-management/dashboard'
